
(() => {
  const init = (root) => {
    if (!root || root.dataset.jtrhReady === 'true') return;
    root.dataset.jtrhReady = 'true';
    document.documentElement.classList.add('jtrh-smooth');

    root.querySelectorAll('a[href^="#"]').forEach((link) => {
      if (link.dataset.jtrhBound === 'true') return;
      link.dataset.jtrhBound = 'true';

      link.addEventListener('click', (event) => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  const initAll = () => {
    document.querySelectorAll('[data-jtrh-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
